import React from 'react'
import { OrderFormat, OutletListItem } from '@ancon/wildcat-types'
import useTranslation from 'next-translate/useTranslation'
import getOutletAvailableOrderFormats from '@ancon/wildcat-utils/outlet/getOutletAvailableOrderFormats'

import BodyText from '../../app/components/BodyText'
import { orderFormatTextMap } from '../../outlets/constants'

import styles from './ProductCardAvailabilityText.module.scss'

export type ProductCardAvailabilityTextProps = {
  productOrderFormat: OrderFormat
  outletOrderFormats: OutletListItem['supportedOrderFormats']
}

export default function ProductCardAvailabilityText({
  productOrderFormat,
  outletOrderFormats,
}: ProductCardAvailabilityTextProps) {
  const { t } = useTranslation('common')

  const outletSupportedOrderFormats =
    getOutletAvailableOrderFormats(outletOrderFormats)

  const productAvailableOrderFormats = outletSupportedOrderFormats.filter(
    orderFormat => (orderFormat & productOrderFormat) === orderFormat,
  )

  function getAvailabilityText() {
    if (!productAvailableOrderFormats.length) {
      return t('components.productCard.notAvailableAtTheMoment')
    }

    const orderFormatTextArray = productAvailableOrderFormats.map(orderFormat =>
      t(`${orderFormatTextMap[orderFormat as never]}`),
    )

    /** Product available order format names */
    let orderFormatTexts

    if (orderFormatTextArray.length > 1) {
      const lastIndex = orderFormatTextArray.length - 1
      const last = orderFormatTextArray[lastIndex]

      orderFormatTexts = `${orderFormatTextArray
        .slice(0, -1)
        // Last item is joined with "and"
        .join(', ')} ${t('components.productCard.and')} ${last}`
    } else {
      const [first] = orderFormatTextArray
      orderFormatTexts = first
    }

    return `${t('components.productCard.onlyAvailableFor')} ${orderFormatTexts}`
  }

  return (
    <BodyText color="body-2" className={styles.availabilityText}>
      {getAvailabilityText()}
    </BodyText>
  )
}
